// extracted by mini-css-extract-plugin
export default {"pageTitle":"AppPage_pageTitle__1GGpr"};